import logo from "../../assets/Mind-Logo.png";
import { MindMapContext } from "../../Context/contex";
import DownloadButton from "../DownloadImageButton/downloadButton";
import './Header.css';
import PrintMindMap from "../Print/printMindMap";
import CompleteDocument from "../CompleteDoc/completeDoc";
import SavingStatus from "../SavingStatus/savingStatus ";
import DocumentTitle from "../DocumentTitle/DocumentTitle";
import ImportExportMenu from "../ImportExport";
import PrivacyIcon from "../PrivacyIcon/PrivacyIcon";
import Separator from "./Separator";
import OfflineStatus from "../OfflineStatus/OfflineStatus";

const Title = () => {
    const { isReadOnly, isTemplateDocument } = MindMapContext();
    const isMobile = window.screen.width < 769;

    return (
        <>
            <div className="header-wrapper">
                <img src={logo} alt="MileDocs Logo" className="header-logo" />
                <Separator wide />
                <DocumentTitle isMobile={isMobile} />
                {!isTemplateDocument && <PrivacyIcon />}
                <Separator />
                <DownloadButton />
                <ImportExportMenu />
                <PrintMindMap />
                {!isReadOnly && !isTemplateDocument && <CompleteDocument />}
                <SavingStatus />
            </div>
            <OfflineStatus />
        </>
    );
};

export default Title;

